/**
 * Maya Premium feature flag.
 *
 * The end-to-end Maya Premium flow (audio preview generation, Stripe purchase,
 * webhook → maya_purchases insert, access unlock on return, confirmation email)
 * is not yet verified working in production. Until every step of the workflow
 * is confirmed end-to-end we hide all Maya Premium UI:
 *   - <MayaHomeSection /> on the home page
 *   - <MayaAudioGuide /> on tour/destination pages (paywall + unlock buttons)
 *   - <MayaAudioPreview /> 30s sample player
 *   - <MyMayaPurchases /> drawer inside the concierge widget
 *
 * Set VITE_MAYA_PREMIUM_ENABLED=false at build time to explicitly disable it.
 */
export const MAYA_PREMIUM_ENABLED =
  import.meta.env.VITE_MAYA_PREMIUM_ENABLED !== "false";
